export function filterAndSortArmas({ armas, q, personaById, titularById }) {
    const term = (q || "").trim().toLowerCase();

    return (armas || [])
        .filter((a) => {
            if (!term) return true;

            const persona = a.personaId ? personaById[a.personaId] : null;
            const titular = a.titularId ? titularById[a.titularId] : null;

            const searchBlob = [
                a.marca,
                a.modelo,
                a.pais,
                a.calibre,
                a.numeroGuia,
                a.numeroSerie,
                a.tipoArmaDescripcion,
                a.tipoArma,

                persona ? `${persona.nombre} ${persona.apellidos}` : "",
                persona?.nickname,

                titular ? `${titular.nombre} ${titular.apellidos}` : "",
                titular?.nickname,
            ]
                .filter(Boolean)
                .join(" ")
                .toLowerCase();

            return searchBlob.includes(term);
        })
        .sort((a, b) => String(a.modelo || "").localeCompare(String(b.modelo || "")));
}
